import headerBg from '@/assets/images/active/snail/doubleFestival/head/bg1.png';
import officeBtn from '@/assets/images/active/snail/doubleFestival/head/official.png';
import loginBtn from '@/assets/images/active/snail/doubleFestival/head/login.png';
import downloadBtn from '@/assets/images/active/snail/doubleFestival/head/download.png';
import logoutBtn from '@/assets/images/active/snail/doubleFestival/head/logout.png';
import accountBtn from '@/assets/images/active/snail/doubleFestival/head/switch.png';
import activeBtn from '@/assets/images/active/snail/doubleFestival/head/download.png';

export const headerConfig = {
    not_logged_in: {
        background_image: headerBg,
        style: ''
    },
    logged_in: {
        background_image: headerBg,
        main_title_color: '#755013',
        sub_title_color: '#755013',
        tips_color: '#5679d0',
        game_name: '最强蜗牛',
    },
    operation_btn: {
        office_website: {
            width: '2.3rem',
            top: '0.2rem',
            height: '',
            background_image: '',
            img: officeBtn,
            link: 'https://snail.qingcigame.com/official/index_mobile.html'
        },
        login: {
            top: '0.2rem',
            width: '',
            height: '',
            background_image: '',
            img: loginBtn,
            style: ''
        },
        change_account: {
            top: '0.2rem',
            width: '',
            height: '',
            background_image: '',
            img: accountBtn,
            style: ''
        },
        join_active: {
            width: '',
            height: '',
            background_image: '',
            img: activeBtn,
            style: '',
            link: ''
        },
        logout: {
            top: '0.2rem',
            width: '',
            height: '',
            img: logoutBtn,
            style: ''
        },
        download: {
            top: '0.2rem',
            width: '',
            height: '',
            img: downloadBtn,
            style: ''
        }
    }
};


// WEBPACK FOOTER //
// ./src/pages/snail/doubleFestival/headerConfig.js